export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-b from-[#F8F7FF] to-white pt-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="container mx-auto px-16 relative z-10">
        <div className="flex items-center justify-between">
          <div className="w-1/2">
            <h2 className="text-7xl font-thin text-[#2A2A2A] leading-tight mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Modern iOS<br />Solutions
            </h2>
            <p className="text-3xl font-light italic text-[#6B6B6B] mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              VPN & Cleaner Applications
            </p>
            <p className="text-base text-[#6B6B6B] leading-relaxed max-w-lg">
              We are a team of experts developing cutting-edge applications for the iOS platform, designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          <div className="w-1/2 flex justify-end items-center relative h-[600px]">
            <div className="absolute right-0 top-1/2 -translate-y-1/2">
              <div className="relative">
                <div className="absolute top-0 right-40 transform rotate-[-8deg]">
                  <div className="bg-white rounded-3xl shadow-2xl p-4 w-64 h-[520px] flex items-center justify-center" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.08)' }}>
                    <img 
                      src="https://public.readdy.ai/ai/img_res/51cd1b820fef8f6e491619e07d54a8aa.jpg" 
                      alt="VPN App Interface"
                      className="w-full h-full object-cover rounded-2xl"
                    />
                  </div>
                </div>

                <div className="absolute top-12 right-0 transform rotate-[6deg]">
                  <div className="bg-white rounded-3xl shadow-2xl p-4 w-64 h-[520px] flex items-center justify-center" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.08)' }}>
                    <img 
                      src="https://readdy.ai/api/search-image?query=elegant%20iOS%20cleaner%20application%20interface%20displaying%20storage%20optimization%20circular%20progress%20indicator%20light%20purple%20gradient%20background%20minimalist%20design%20clean%20modern%20mobile%20app%20screen%20professional%20utility%20software&width=240&height=500&seq=hero-phone-2&orientation=portrait" 
                      alt="Cleaner App Interface"
                      className="w-full h-full object-cover rounded-2xl"
                    />
                  </div>
                </div>

                <div className="absolute top-24 right-[-80px] transform rotate-[15deg]">
                  <div className="bg-white rounded-3xl shadow-2xl p-4 w-64 h-[520px] flex items-center justify-center" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.08)' }}>
                    <img 
                      src="https://readdy.ai/api/search-image?query=sophisticated%20mobile%20security%20app%20dashboard%20on%20iPhone%20showing%20real-time%20protection%20status%20teal%20accent%20colors%20modern%20minimalist%20interface%20clean%20typography%20professional%20iOS%20application%20design&width=240&height=500&seq=hero-phone-3&orientation=portrait" 
                      alt="Security App Interface"
                      className="w-full h-full object-cover rounded-2xl"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
